import BasePopup from "@/popups/basePopup"

export default class TextPopup extends BasePopup {
	#title
	#text
	#btnSelector

	constructor(title, text, id, btnSelector) {
		super(id)
		this.#title = title
		this.#text = text
		this.#btnSelector = btnSelector
	}

	// getters

	get title() {
		return this.#title
	}
	get text() {
		return this.#text
	}
	get btnSelector() {
		return this.#btnSelector
	}

	// setters

	set title(val) {
		this.#title = val
	}
	set text(val) {
		this.#text = val
	}

	// private methods

	#getContentHTML() {
		return `
            <div class="text-popup-content d-flex flex-column bg-white px-4 py-3 m-md-5 position-relative" style="border-radius: 20px;">
                <div>
                    <div class="bg-white">
                        <div class="d-flex weight-700 font-24 flex-row nowrap justify-content-between sticky-top bg-white py-3 mb-3 border-bottom border-gray">
                            <div class="popup-content-title title-2 text-grey-900">${
															this.#title
														}</div>
                            <div class="d-flex align-items-start justify-content-center">
                                <div class="popup-cls cursor-pointer d-flex align-items-center justify-content-center bg-light-gray rounded-circle" style="width: 40px; height: 40px;">
                                    <span class="px-1">x</span>
                                </div>
                            </div>
                        </div>
                        <div data-popup-content-text class="popup-content-text text-grey-900">
                            ${this.#text}
                        </div>
                    </div>
                </div>
            </div>
        `
	}
	#getClsBtn() {
		return this.getRootDiv().querySelector(".popup-cls")
	}
	#getActivatingBtn() {
		return document.querySelector(this.#btnSelector)
	}
	#setStyles() {
		if (window.screenSizeManager.screenType !== "mobile") {
			this.getRootDiv().querySelector(
				".text-popup-content"
			).style.borderRadius = "20px"
		}
	}
	#setListeners() {
		this.#getActivatingBtn()?.addEventListener("click", () => {
			this.display()
		})
		this.#getClsBtn()?.addEventListener("click", () => {
			this.hide()
		})
		window.addEventListener("screenTypeChange", () => {
			this.#setStyles()
		})
	}

	// public methods

	initTextPopup() {
		if (!this.#title || !this.#text) {
			this.#getActivatingBtn().style.display = "none"
			return
		}

		this.injectContentHTML(this.#getContentHTML())

		this.#setListeners()
	}

	refreshContents() {
		this.getPopupContentDiv().querySelector(".popup-content-title").innerHTML =
			this.#title
		this.getPopupContentDiv().querySelector(".popup-content-text").innerHTML =
			this.#text
	}
}
